// Small form helpers shared by the page scripts in wwwroot/js/custom.

// Show or clear a server-style validation message in an asp-validation-for span.
export function setFieldError(element, message) {
  if (!element) {
    return;
  }

  element.classList.toggle('field-validation-error', !!message);
  element.classList.toggle('field-validation-valid', !message);
  element.textContent = message || '';
}

// Add or remove an item in the form's validation summary, if it has one.
export function setSummaryError(key, message) {
  const list = document.querySelector('.validation-summary-errors ul');

  if (!list) {
    return;
  }

  let item = list.querySelector(`li[data-key="${key}"]`);

  if (message && !item) {
    item = document.createElement('li');
    item.dataset.key = key;
    list.append(item);
  }

  if (item) {
    if (message) {
      item.textContent = message;
    } else {
      item.remove();
    }
  }
}

// Froala keeps its textarea hidden, so the validator skips it; this checks the
// editor itself when the form is submitted.
export function requireEditorText(form, messageElement, message) {
  form?.addEventListener('submit', (event) => {
    const empty = window.froalaEditor?.core.isEmpty();

    setFieldError(messageElement, empty ? message : '');

    if (empty) {
      event.preventDefault();
      window.froalaEditor.events.focus(true);
    }
  });
}

// Show `section` while `checkbox` is ticked; unticking clears `clearInput`.
export function toggleWithCheckbox(checkbox, section, clearInput) {
  if (!checkbox || !section) {
    return;
  }

  const sync = () => {
    section.style.display = checkbox.checked ? '' : 'none';

    if (clearInput) {
      clearInput.value = '';
    }
  };

  checkbox.addEventListener('change', sync);
  sync();
}

// "Remove logo" buttons: hide the current image and blank the hidden path field.
export function removeExistingImage(imageSelector, pathSelector) {
  document.querySelectorAll(imageSelector).forEach((element) => {
    element.style.display = 'none';
  });
  document.querySelectorAll(pathSelector).forEach((input) => {
    input.value = '';
  });
  return false;
}
